"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useActivePdfDownloader_1 = require("./useActivePdfDownloader");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return useActivePdfDownloader_1.default; } });
//# sourceMappingURL=index.js.map